var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInspect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline/terminal"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M1.66669 5C1.66669 3.61929 2.78598 2.5 4.16669 2.5H15.8334C17.2141 2.5 18.3334 3.61929 18.3334 5V15C18.3334 16.3807 17.2141 17.5 15.8334 17.5H4.16669C2.78598 17.5 1.66669 16.3807 1.66669 15V14.8333C1.66669 14.3731 2.03978 14 2.50002 14C2.96026 14 3.33335 14.3731 3.33335 14.8333V15C3.33335 15.4602 3.70645 15.8333 4.16669 15.8333H15.8334C16.2936 15.8333 16.6667 15.4602 16.6667 15V5C16.6667 4.53976 16.2936 4.16667 15.8334 4.16667H4.16669C3.70645 4.16667 3.33335 4.53976 3.33335 5V9.16667C3.33335 9.6269 2.96026 10 2.50002 10C2.03978 10 1.66669 9.6269 1.66669 9.16667V5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75009 7.5C8.75009 7.08579 9.08588 6.75 9.50009 6.75H13.5001C13.9143 6.75 14.2501 7.08579 14.2501 7.5V11.5C14.2501 11.9142 13.9143 12.25 13.5001 12.25C13.0859 12.25 12.7501 11.9142 12.7501 11.5V9.28869L9.1743 12.6794C8.88121 12.9697 8.40826 12.9688 8.11623 12.6768C8.08946 12.65 8.06912 12.6175 8.05674 12.5817L7.35769 10.5602L3.1452 12.7066C2.85069 12.9693 2.39869 12.9594 2.11609 12.6768C1.8232 12.3839 1.8232 11.909 2.11609 11.6161C2.13299 11.5992 2.15222 11.5848 2.17319 11.5734L6.99842 8.94246C7.29285 8.67708 7.7469 8.68614 8.03042 8.96967C8.0572 8.99645 8.07754 9.02895 8.08992 9.06474L8.75642 10.9921L11.6636 8.25H9.50009C9.08588 8.25 8.75009 7.91421 8.75009 7.5Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspect);
export default __webpack_public_path__ + "static/media/inspect.3db466200351da74dc07f4e866acb44d.svg";
export { ForwardRef as ReactComponent };